import { FormikProps } from "formik";
import React from "react";
import { Citizenship } from "./Citizenship";
import { Pep } from "./Pep";
import { CitizenshipPepFormValues } from "./interfaces";

interface Props {
  formProps: FormikProps<CitizenshipPepFormValues>;
}

export const CitizenshipPepFormElements = ({
  formProps,
}: Props): React.ReactElement => (
  <div className="data-hj-suppress">
    <Citizenship formProps={formProps} />
    <Pep formProps={formProps} />
  </div>
);
